<template>
    <div class="search-box" :class="issearching?'searching':''">
        <div class="simple-search" v-if="!issearching" @click="handleSearch">
            <van-icon name="search"/>
            <span>搜索</span>
        </div>
        <div class="fae-search" v-if="issearching">
            <div class="search-input">
                <div class="search-item">
                    <sintelligent
                            :moduleId='this.CoreNew.SYSTABLE.USER'
                            :label="'FAE的姓名'"
                            :sVal="faename"
                            @confirm="confirmFaename"
                            @onCancel="cancelFaename"
                    >
                    </sintelligent>
                </div>
                <div class="search-item">
                    <sintelligent
                            :moduleId='this.CoreNew.SYSTABLE.PRO_LINE'
                            :label="'产品线'"
                            :sVal="productline"
                            @confirm="confirmProductline"
                            @onCancel="cancelProductline"
                    >
                    </sintelligent>
                </div>
                <div class="search-item">
                    <svradio
                            :label="'应用领域'"
                            :sVal="segment"
                            :sdata="'segment'"
                            @confirm="confirmSegment"
                            @onCancel="cancelSegment"
                    >
                    </svradio>
                </div>
                <div class="search-item">
                    <svradio
                            :label="'办公地址'"
                            :sVal="location"
                            :sdata="'location'"
                            @confirm="confirmLocation"
                            @onCancel="cancelLocation"
                    >
                    </svradio>
                </div>
            </div>
            <div class="search-btn">
                <van-button type="primary" class="faesearch-btn" @click="onSearch">搜索</van-button>
                <van-button class="faecancel-btn" @click="onCancel">取消</van-button>
            </div>
        </div>
        <div class="search-mark" v-if="showmark" :style="'height:'+wheight+'px'" @click="cancelMark"></div>
    </div>
</template>

<script>
    import common from '@/api/common';

    import svradio from "./svradio";
    import sintelligent from "./sintelligent";

    export default {
        name: "search",
        components: {svradio, sintelligent},
        data() {
            return {
                issearching: false,

                faename: '',        // fae name
                faenameId:'',

                productline: '',    // 产品线显示
                productlineId:'',

                segment: '',        // 领域
                segmentId:'',

                location:'',        // 办公地址
                locationId:''
            }
        },
        computed: {
            wheight() {
                let h = document.body.clientHeight || document.body.clientHeight || document.documentElement.clientHeight;
                if (h) {
                    return h
                } else {
                    return 400
                }
            },
            showmark() {
                if (this.faeshowcell || this.proshowcell) {
                    return true
                } else {
                    return false
                }
            }
        },
        mounted() {

        },
        methods: {
            handleSearch() {
                this.issearching = !this.issearching
            },
            onSearch() {
                let data = {
                    faeValue: this.faename,
                    prolineValue: this.productline,
                    segment: this.segmentId,
                    location:this.location
                };
                // console.log(data)
                this.$emit('searchData', data);
            },
            onCancel() {
                this.issearching = !this.issearching;
                this.initSearch();
                this.$emit('oncancel');
            },
            initSearch() {
                this.faename = '';     // fae name
                this.faenameId = '';
                this.productline = ''; // 产品线显示
                this.productlineId = '';
                this.segment = '';      //领域
                this.segmentId = '';
                this.location = '';      //办公地址
                this.locationId = '';
            },

            cancelMark() {

            },

            confirmFaename(data) {
                this.faename = data.name;
                this.faenameId = data.id;
            },
            cancelFaename(data){
                this.faename = data.name;
                this.faenameId = data.id;
            },
            confirmProductline(data){
                this.productline = data.name;
                this.productlineId = data.id;
            },
            cancelProductline(data){
                this.productline = data.name;
                this.productlineId = data.id;
            },
            confirmLocation(data){
                this.location = data.name;
                this.locationId = data.id;
            },
            cancelLocation(data){
                this.location = data.name;
                this.locationId = data.id;
            },
            confirmSegment(data){
                this.segment = data.name;
                this.segmentId = data.id;
            },
            cancelSegment(data){
                this.segment = '';
                this.segmentId ='';
            },
          // // 获取领域的数据
          // getFindDic() {
          //   try {
          //     let stoSegment = JSON.parse(localStorage.getItem('FIND_DIC_INFO_FAE')).SEGMENT;
          //   }catch (e) {
          //     let fieldName = 'SEGMENT';
          //     let moduleId = this.CoreNew.SYSTABLE.FAE;
          //     let systemId = '';
          //     common.findDicInfo(fieldName, moduleId, systemId).then(res => {
          //       if (res && res.flag && res.data) {
          //         let data = res.data;
          //         localStorage.setItem('FIND_DIC_INFO_FAE', JSON.stringify(data));
          //       }
          //     })
          //   }
          // },
        }
    }
</script>

<style scoped lang="less">
    //@import "../../../assets/css/base.less";

    .search-box {
        background: #f2f2f2;
        position: relative;
        z-index: 100;
        padding: 10px;

        .search-mark {
            position: fixed;
            left: 0;
            top: 130px;
            z-index: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .1);
        }


        .simple-search {
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 30px;
            font-size: 14px;

            .van-icon {
                font-size: 16px;
                margin-right: 5px;
            }
        }

        .fae-search {
            display: flex;
            width: 100%;
            flex-direction: column;
            position: relative;
            z-index: 1;

            .search-input {
                width: 100%;
                position: relative;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
                margin-bottom: 5px;

                .search-item {
                    width: 49%;
                    position: relative;
                    box-sizing: border-box;
                    margin-bottom: 5px;
                    /deep/ .van-icon-search{
                        color: @font9;
                    }
                }

                .search-item:last-child {
                    margin-bottom: 0;
                }

                /deep/ .van-field {
                    padding: 5px 10px;
                }


                /deep/ .van-picker-column__item--selected {
                    color: @bule;
                }

                /deep/ .van-cell {
                    font-size: 14px;

                }

                /deep/ .van-field__control {
                    font-size: 14px;
                }

                /deep/ textarea.van-field__control {
                    min-height: 68px;
                }

                .list-pop {
                    position: absolute;
                    z-index: 10;
                    width: 100%;
                    background: #fff;
                    max-height: 260px;
                    overflow-y: auto;
                    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
                }

                .van-search {
                    margin-bottom: 5px;
                    padding: 0;

                    .van-search__content {
                        background: #fff
                    }

                    /deep/ .van-field__control {
                        font-size: 14px;
                    }
                }

                .van-search:last-child {
                    margin-bottom: 0
                }

                .segment .van-field {
                    /*padding: 5px 8px 5px 10px;*/

                    /*/deep/ .van-field__control {*/
                    /*    font-size: 14px;*/
                    /*}*/

                }

                .segment {
                    position: relative;
                }

            }

            .search-btn {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                .van-button{
                    box-sizing: border-box;
                    width: 49%;
                    height: 34px;
                    min-height: 34px;
                    padding: 0px;
                }

                .faesearch-btn {
                    background: @linearBlue;
                }

                .faecancel-btn {
                    background: @linearGray;
                }
            }

        }

        .van-popup {
            .segment-btn {
                //position: absolute;
                //width: 100%;
                //box-sizing: border-box;
                //z-index: 1;
                //top: 0;
                //left: 0;
                padding: 0 15px;
                height: 40px;
                background: #eee;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .van-checkbox-group {
                width: 100%;
                position: absolute;
                height: 360px;
                overflow: scroll;
            }
        }

    }

    .search-box.searching {
        box-shadow: 0 0 20px rgba(0, 0, 0, .3)
    }


</style>